module.exports = __webpack_public_path__ + "img/gift-workmate-bottom.af6e0ded.png";